import { useMutation } from "@tanstack/react-query";
import api from "apis";

const useVerifyPasswordMutation = () => {
  return useMutation({
    mutationFn: api.user.verifyPassword,
  });
};

export default useVerifyPasswordMutation;
